import store from '../../store/store';

export const contactAdmin = (emailSubject, emailBody, supportEmail = null) => {
  const { home } = store.getState();

  let emailToSend = home?.adminDetails?.email;

  if (supportEmail) {
    emailToSend = supportEmail;
  }

  const normalizeLineBreaks = (text: string) =>
    text.replace(/%0D%0A/gi, '\n');

  const encodedEmail = encodeURIComponent(emailToSend || '');
  const encodedSubject = encodeURIComponent(normalizeLineBreaks(emailSubject));
  const encodedBody = encodeURIComponent(normalizeLineBreaks(emailBody));

  const mailString = `mailto:${encodedEmail}?subject=${encodedSubject}&body=${encodedBody}`;

  window.open(mailString, '_blank');
};
